import { type EvidenceDefinition, type JsonSchema } from "./types";

export function extractCursorFromUrl(url: string): string | undefined {
  try {
    const parsedUrl = new URL(url, "https://placeholder.com");
    return parsedUrl.searchParams.get("page[cursor]") ?? undefined;
  } catch {
    return undefined;
  }
}

export function cleanProperties(
  properties: Record<string, unknown>,
  schema: JsonSchema
): Record<string, unknown> {
  const schemaProperties = schema.properties ?? {};
  const cleaned: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(properties)) {
    const propertySchema = schemaProperties[key];
    if (!propertySchema) {
      continue;
    }

    if (
      propertySchema.type === "object" &&
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value)
    ) {
      const nestedCleaned = cleanProperties(value as Record<string, unknown>, propertySchema);
      if (Object.keys(nestedCleaned).length > 0) {
        cleaned[key] = nestedCleaned;
      }
    } else if (value !== "" && value !== undefined && value !== null) {
      cleaned[key] = value;
    }
  }

  return cleaned;
}

export function isUnknownEvidenceDefinition(definition: EvidenceDefinition | undefined): boolean {
  return definition?.attributes.displayName.includes("UNKNOWN") ?? false;
}
